module.exports = __webpack_public_path__ + "e40c722f1a80a8ed8ce7563a7838f169.gif";